var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_747_1362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6011 5.16073C16.4727 5.03608 16.3008 4.96637 16.1219 4.96641L7.04736 4.96641C6.95591 4.96455 6.86501 4.98095 6.77998 5.01466C6.69494 5.04838 6.6175 5.09871 6.55216 5.16273C6.48683 5.22675 6.43493 5.30316 6.39949 5.38749C6.36406 5.47181 6.34581 5.56236 6.34581 5.65383C6.34581 5.7453 6.36406 5.83585 6.39949 5.92018C6.43493 6.00451 6.48683 6.08092 6.55216 6.14494C6.6175 6.20895 6.69494 6.25929 6.77998 6.293C6.86501 6.32671 6.95591 6.34312 7.04736 6.34126L14.4622 6.34126L4.94077 15.8627C4.87544 15.9262 4.82338 16.0021 4.78762 16.0859C4.75187 16.1697 4.73312 16.2597 4.73248 16.3508C4.73183 16.4419 4.7493 16.5323 4.78387 16.6166C4.81844 16.7009 4.86942 16.7775 4.93385 16.8419C4.99827 16.9063 5.07486 16.9573 5.15916 16.9919C5.24345 17.0264 5.33378 17.0439 5.42489 17.0433C5.516 17.0426 5.60607 17.0239 5.68987 16.9881C5.77367 16.9523 5.84953 16.9003 5.91304 16.835L15.4345 7.31353L15.4345 14.7284C15.4326 14.8198 15.449 14.9107 15.4827 14.9958C15.5164 15.0808 15.5668 15.1582 15.6308 15.2236C15.6948 15.2889 15.7712 15.3408 15.8556 15.3762C15.9399 15.4117 16.0304 15.4299 16.1219 15.4299C16.2134 15.4299 16.3039 15.4117 16.3882 15.3762C16.4726 15.3408 16.549 15.2889 16.613 15.2236C16.677 15.1582 16.7274 15.0808 16.7611 14.9958C16.7948 14.9107 16.8112 14.8198 16.8093 14.7284L16.8093 5.65383C16.8093 5.56189 16.7909 5.47088 16.7552 5.38619C16.7194 5.30149 16.667 5.22483 16.6011 5.16073Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_747_1362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopRightArrow);
export default __webpack_public_path__ + "static/media/TopRightArrow.9e817272fb4fe58e78f4e5f35da5838e.svg";
export { ForwardRef as ReactComponent };